import { Dialog, Box, Typography, Stack, Button } from "@mui/material";

export default function ConfirmDialog({
  open,
  title = "Confirm Action",
  description = "",
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false,
  onConfirm,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose} sx={{
    "& .MuiDialog-paper": {
      margin: "8px",                 // 👈 reduce outer margin
      width: "calc(100% - 16px)",    // 👈 prevents overflow
    },
  }}>
      <Box p={3} width={360}>
        <Typography fontWeight={900}>{title}</Typography>

        {description && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 1 }}
          >
            {description}
          </Typography>
        )}

        <Stack direction="row" spacing={1.5} mt={3}>
          <Button
            fullWidth
            variant="outlined"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </Button>

          <Button
            fullWidth
            variant="contained"
            color="error"
            onClick={onConfirm}
            disabled={loading}
          >
            {confirmText}
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
}
